import React from 'react';
import { FC, useState } from 'react';
import { CSVImportComponentProps } from './CSVImport.interfaces';

export const CSVImportComponent: FC<CSVImportComponentProps> = props => {
  const { inputRef, filesSelected } = props;
  //Used to reset input value!
  const [inputKey, setInputKey] = useState(Date.now().toString());
  return (
    <input
      type="file"
      key={inputKey}
      ref={inputRef}
      onChange={event => {
        filesSelected?.(event.target.files);
        setInputKey(Date.now().toString());
      }}
      style={{ display: 'none' }}
      accept=".csv"
    />
  );
};
